import { API } from 'aws-amplify';

class FlightsService {
   getData = async (airlineCode) => {
          var ReturnObj = [];
      
      await API.get('IAPI', 'Flight/flights/', {
         'queryStringParameters': {
            'airlineCode': airlineCode
         }
      }).then((res) => {
         ReturnObj = res;
         return res;
      }).catch((error) => {
         return error;
      }
      );
      return ReturnObj;
   }

   addData = async (values) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            flightCode: values.flightCode,
            arrivalAirport: values.arrivalAirport.value,
            departureAirport: values.departureAirport.value,
            flightDateTime: values.flightDateTime,
            airlineId: values.airlineId,
            direction: values.direction,
            contactFirstName: values.contactFirstName, contactLastName: values.contactLastName,
            contactPhone: values.contactPhone, contactFaxNo: values.contactFaxNo, contactEmail: values.contactEmail
         }
      }
      await API.post('IAPI', 'Flight/createUpdate/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );

      return ReturnObj;
   }

   updateData = async (values) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            id: values.id,
            flightCode: values.flightCode,
            arrivalAirport: values.arrivalAirport,
            departureAirport: values.departureAirport,
            flightDateTime: values.flightDateTime,
            airlineId: values.airlineId,
            direction: values.direction,
            contactFirstName: values.contactFirstName, 
            contactLastName: values.contactLastName,
            contactPhone: values.contactPhone, 
            contactFaxNo: values.contactFaxNo, 
            contactEmail: values.contactEmail
         }
      }
      await API.post('IAPI', 'Flight/createUpdate/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }

   deleteFlight = async (flight) => {
      var ReturnObj = {};
      var myInit = {
         body: {//TODO - send only id
            id: flight.id,
            FlightCode: flight.flightCode,
            ArrivalAirport: flight.arrivalAirport,
            FlightDateTime: flight.flightDateTime,
            ContactFirstName: flight.contactFirstName, ContactLastName: flight.contactLastName,
            ContactPhone: flight.contactPhone, ContactFaxNo: flight.contactFaxNo, ContactEmail: flight.contactEmail          
         }
      }
      await API.post('IAPI', 'Flight/CancelFlight/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   };

   closeFlight = async (flight) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            id: flight.id,
            flightCode: flight.flightCode,
            flightDateTime:flight.flightDateTime,
            arrivalAirport: flight.arrivalAirport,
            departureAirport: flight.departureAirport,
            departureDateAndTime: flight.departureDateAndTime,
            contactFirstName: flight.contactFirstName, contactLastName: flight.contactLastName,
            contactPhone: flight.contactPhone, contactFaxNo: flight.contactFaxNo, contactEmail: flight.contactEmail,
            IsActive: true
         }
      }
      await API.post('IAPI', 'Flight/close/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   };

   getCurrentFlight = async (id) => {
      var ReturnObj = {};
      await API.get('IAPI', 'Flight/currentFlight/', {
         'queryStringParameters': {
            'id': id
         }
      }).then((res) => {
         ReturnObj = res;
         return res;
      }).catch((error) => {
         return error;
      }
      );
      return ReturnObj;
   };

   
   findFlightBeforeAdd = async (flight) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            flightCode: flight.flightCode,
            flightDate: flight.flightDateTime,
         }
      }
      await API.post('IAPI', 'Flight/findFlight/', myInit
      ).then((res) => {
         ReturnObj = res;
         return res;
      }).catch((error) => {
         return error;
      }
      );
      return ReturnObj;
   };

   findFlight = async (flight) => {
      var ReturnObj = {};
      var myInit = {
         body: {
            flightCode: flight.FlightNumber,
            flightDate: flight.FlightDate,
         }
      }
      await API.post('IAPI', 'Flight/findFlight/', myInit
      ).then((res) => {
         ReturnObj = res;
         return res;
      }).catch((error) => {
         return error;
      }
      );
      return ReturnObj;
   };

   getMqData = async () => {
      var ReturnObj = {};
      var myInit = {
         body: {
            MqMessage: "XXX"
         }
      }

      await API.post('IAPI', 'Airports/callmq/', myInit)
         .then((res) => {
            ReturnObj = res;
            return res;
         }).catch((error) => {
            return error;
         }
         );
      return ReturnObj;
   }
}

export default new FlightsService();